<template>
  <div class="shelf-preview">
    <div class="shelf-preview__close" @click="$emit('close-modal')"></div>
    <div class="shelf-preview__overlay"></div>
    <div class="shelf-preview__inner position-r">
      <div
        class="shelf-preview__arrow"
        :class="{ 'shelf-preview__arrow--disabled': currentShelf === 0 }"
        @click="setActiveShelf(-1)"
        v-if="shelfList.length > 1"
      ></div>
      <div
        class="shelf-preview__arrow shelf-preview__arrow--right"
        :class="{
          'shelf-preview__arrow--disabled':
            currentShelf === shelfList.length - 1,
        }"
        @click="setActiveShelf(1)"
        v-if="shelfList.length > 1"
      ></div>
      <div
        class="shelf-preview__image-wrapper position-r"
        id="shelf-modal-img"
        :class="{ 'image-loading': loadingImage }"
      >
        <panZoom id="modal-panzoom-details">
          <div class="zoomable">
            <img :src="shelfList[currentShelf].imageURL" @load="onLoad" />
          </div>
        </panZoom>
        <div class="shelf-preview__count">
          {{ currentShelf + 1 }} / {{ shelfList.length }}
        </div>
      </div>
      <div class="flex items-center shelf-preview__tools-zoom">
        <div class="flex items-center shelf-preview__tools-zoom-controls">
          <div
            class="flex items-center justify-center shelf-preview__tools-zoom-cta"
            @click="zoom(-1)"
            :disabled="imageZoomPercent === 25"
          >
            -
          </div>
          <span>{{ imageZoomPercent }}%</span>
          <div
            class="flex items-center justify-center shelf-preview__tools-zoom-cta shelf-preview__tools-zoom-cta--plus"
            @click="zoom(1)"
            :disabled="imageZoomPercent === 100"
          >
            +
          </div>
        </div>
      </div>
      <div class="shelf-preview__info">
        <ul class="shelf-library-item__info">
          <li>
            <strong>Project:</strong> {{ shelfList[currentShelf].Name }}
            <span class="no-white-space"
              >({{ shelfList[currentShelf].numberOfProducts }} products)</span
            >
          </li>
          <li>
            <strong>Project Date:</strong>
            {{ shelfList[currentShelf].date }}
          </li>
          <li>
            <strong>Retailer:</strong>
            {{ shelfList[currentShelf].Retailer }}
          </li>
        </ul>
      </div>
      <div class="shelf-preview__controls flex justify-end">
        <div class="flex">
          <a-button
            type="primary"
            @click="$emit('select-shelf', shelfList[currentShelf])"
            :class="{
              dlb:
                surveyType === 'packtestextend' &&
                shelfList[currentShelf].shelfID !== activeShelfId,
            }"
          >
            <span v-if="shelfList[currentShelf].shelfID !== activeShelfId"
              ><font-awesome-icon icon="check" class="mr-5" /> Select
              shelf</span
            >
            <span v-else
              ><font-awesome-icon icon="list" class="mr-5" /> Select Test
              Products</span
            >
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Panzoom from "panzoom";

export default {
  name: "ShelfPreviewModal",
  components: {},
  props: {
    shelfList: {
      type: Array,
      default() {
        return [];
      },
    },
    currentShelf: {
      type: Number,
    },
    activeShelfId: {
      type: Number,
      default() {
        return null;
      },
    },
    surveyType: {
      type: String,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      currentZoomLevel: 1,
      imageZoomPercent: 50,
      activeShelf: 0,
      loadingImage: true,
      imageCurrentWidth: 1,
    };
  },
  computed: {},
  watch: {},
  methods: {
    zoom(level) {
      const container = document.querySelector("#shelf-modal-img");
      const rect = container.getBoundingClientRect();
      const cx = rect.x + rect.width / 2;
      const cy = rect.y + rect.height / 2;

      const zoomLevels = [0.5, 1, 1.5, 2];
      const currentIndex = zoomLevels.indexOf(this.currentZoomLevel);
      let newIndex;
      if (level === -1) {
        newIndex = currentIndex - 1;
      } else {
        newIndex = currentIndex + 1;
      }
      if (newIndex >= 0 && newIndex < zoomLevels.length) {
        const newZoomLevel = zoomLevels[newIndex];
        this.panzoomDetails.zoomAbs(cx, cy, newZoomLevel);
        this.currentZoomLevel = newZoomLevel;
        this.setImageZoomPercent(newZoomLevel);
      }
    },
    setImageZoomPercent(zoomStep) {
      switch (zoomStep) {
        case 0.5:
          this.imageZoomPercent = 25;
          break;
        case 1:
          this.imageZoomPercent = 50;
          break;
        case 1.5:
          this.imageZoomPercent = 75;
          break;
        case 2:
          this.imageZoomPercent = 100;
          break;
        default:
          break;
      }
    },
    setActiveShelf(step) {
      this.loadingImage = true;
      this.setImageZoomPercent(1);
      this.currentZoomLevel = 1;
      if (step === -1) {
        this.activeShelf--;
      } else {
        this.activeShelf++;
      }
      this.$emit("set-active-shelf", this.activeShelf);
    },
    onLoad() {
      this.loadingImage = false;
    },
  },
  mounted() {
    this.panzoomDetails = Panzoom(
      document.getElementById("modal-panzoom-details"),
      {
        bounds: true,
        boundsPadding: 0.1,
        maxZoom: 3,
        minZoom: 0.1,
        transformOrigin: { x: 0.5, y: 0.5 },
        disableZoom: true,
        beforeWheel: function (e) {
          var shouldIgnore = !e.altKey;
          return shouldIgnore;
        },
        onTouch: function () {
          return false;
        },
      }
    );
    this.activeShelf = this.currentShelf;
  },
  created() {
    this.image = this.$refs.image;
  },
  activated() {},
};
</script>

<style lang="scss" scoped>
.shelf-preview {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  &__close {
    position: absolute;
    top: 25px;
    right: -12px;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 1;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #555555;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
  &__arrow {
    position: absolute;
    left: -45px;
    top: 50%;
    transform: translateY(-50%) rotate(-135deg);
    width: 34px;
    height: 34px;
    cursor: pointer;
    z-index: 1;
    border-color: #555555;
    border-width: 2px 2px 0 0;
    border-style: solid;
    transition: color 0.3s ease;
    &--right {
      left: auto;
      right: -45px;
      transform: translateY(-50%) rotate(45deg);
    }
    &:hover {
      border-color: #000;
    }
    &--disabled {
      pointer-events: none;
      opacity: 0.25;
    }
  }
  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.963);
  }
  &__inner {
    max-width: 85%;
    background: #fff;
    border-radius: 6px;
    z-index: 1;
    width: 100%;
    position: relative;
    box-shadow: 0px 4px 12px 3px rgba(0, 0, 0, 0.14);
    padding: 8px;
    height: 90%;
    display: flex;
    flex-direction: column;
    margin: 0 80px;
  }
  &__image-wrapper {
    flex: 1;
    overflow: hidden;
    border-radius: 6px;
    background: #2e2e2e;
    margin-bottom: 15px;
    img {
      width: 100%;
      height: 100%;
    }
    ::v-deep {
      .zoomable {
        transform: none !important;
      }
    }
  }
  &__info {
    .shelf-library-item__info {
      padding-left: 3px;
      li {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  &__controls {
    border-top: 1px solid #eaeaea;
    margin: 14px -15px 0;
    padding: 10px 15px 2px 10px;

    .ant-btn {
      height: 36px;
    }
  }
  &__tools {
    position: absolute;
    left: 0;
    width: 100%;
    background: #f5f5f5;
    bottom: 0;
    width: 100%;
    padding: 8px 10px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.55);
  }
  &__tools-zoom {
    position: absolute;
    left: 50%;
    bottom: 180px;
    transform: translateX(-50%);
    > span {
      padding-right: 5px;
      font-size: 14px;
      color: #c6c6c6;
    }
  }
  &__tools-zoom-controls {
    background: rgba(230, 230, 230, 0.9);
    padding: 9px 6px;
    border-radius: 4px;
    min-width: 110px;
    display: flex;
    justify-content: space-between;
    span {
      padding: 0 8px;
      font-size: 14px;
      font-weight: 500;
    }
  }
  &__tools-zoom-cta {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #2e2e2e;
    font-size: 26px;
    background: #2e2e2e;
    color: #fff;
    cursor: pointer;
    transition: 0.3s ease all;
    &[disabled] {
      opacity: 0.7;
      cursor: not-allowed;
    }
    &:hover {
      background: #262626;
    }
    &--plus {
      font-size: 18px;
    }
  }
  &__count {
    position: absolute;
    right: 15px;
    bottom: 15px;
    background: #e6e6e6;
    padding: 2px 6px;
    font-weight: 500;
    border-radius: 4px;
    background: rgba(230, 230, 230, 0.9);
    font-size: 14px;
  }
}
</style>
